import React, { Component } from 'react'
import AOS from 'aos';
import './css/whattolearn.css'

class Whattolearn extends Component {
    componentDidMount() {
        // or simply just AOS.init();
        AOS.init({
          // initialise with other settings
          duration : 1000
        });
      }
    render() {
        return (
            <div className="learn">
                <div className="whattolearn">
                    <div className="wvid">

                    </div>
                    <div className="wtext" data-aos="zoom-in-left" data-aos-delay="80" data-aos-duration="1400">
                        <h2>
                        What you will be learning.
                        </h2>
                        <p>Highlight of our curriculum and everything you will be learning when <br/>you sign up with us!</p>
                    </div>
                </div>
                <div className="whattolearn2">
                    <div className="ss" data-aos="zoom-in-right" data-aos-delay="100" data-aos-duration="1600">
                        <h2>
                        What comes next?
                        </h2>
                    </div>
                    <div className="wvidd">

                    </div>
                </div>
            </div>  
        )
    }
}

export default Whattolearn;